<template>
  <div class="dialog-wrap" :class="{ 'has-other-tips': tips }">
    <transition name="scale-in" @after-leave="closeDialog">
      <div v-if="showContent" class="dialog-container">
        <p class="dialog-title">{{ myTitle }}</p>
        <div
          class="dialog-tips-content"
          :class="[textAlign, { 'mb-30': hideButton }]"
          v-html="content"
        ></div>
        <p v-if="tips" class="tips-tips">{{ tips }}</p>
        <div v-if="type == 'tips' && !hideButton" class="account-ops">
          <Button
            class="swtich-account btn long-btn"
            pointClass="j-sure-tip-btn"
            @click="sendConfirmEvt"
          >
            {{ myConfirm }}
          </Button>
        </div>
        <div v-else-if="!hideButton" class="account-ops">
          <Button
            class="cencel-account btn cancel-btn"
            pointClass="j-cancle-tip-btn"
            @click="sendCancelEvt"
          >
            {{ myCancel }}
          </Button>
          <Button
            class="swtich-account btn confirm-btn"
            pointClass="j-sure-tip-btn"
            @click="sendConfirmEvt"
          >
            {{ myConfirm }}
          </Button>
        </div>
        <Button
          class="close-btn"
          pointClass="j-close-tip-btn"
          v-if="!hideButton"
          @click="hideContent"
        ></Button>
      </div>
    </transition>
    <transition name="fade-in">
      <div v-if="showContent" @click="hideContent" class="dialog-shade"></div>
    </transition>
  </div>
</template>

<script>
export const CLOSE_DIALOG_EVENT = 'close_dialog';
export const CANCEL_EVENT = 'onCancel';
export const CONFIRM_EVENT = 'onConfirm';
export const SHOW_TIPS = 'showTipsDialog';
export const RESET_CONFIG = 'resetConfig';
export default {
  props: [
    'content',
    'title',
    'cancel',
    'confirm',
    'languages',
    'type',
    'tips',
    'textAlign',
    'limitKey',
    'limitText',
    'disableClose',
    'hideButton'
  ],
  data() {
    return {
      showContent: false,
      operateType: ''
    };
  },
  computed: {
    myTitle() {
      let tips = '';
      try {
        tips = this.title || this.languages.tips.toUpperCase();
      } catch {
        tips = 'tips';
      }
      return tips;
    },
    myCancel() {
      let cancel = '';
      try {
        cancel = this.cancel || this.languages.cancel.toUpperCase();
      } catch {
        cancel = 'CANCEL';
      }
      return cancel;
    },
    myConfirm() {
      let confirm = '';
      try {
        confirm = this.confirm || this.languages.confirm.toUpperCase();
      } catch {
        confirm = 'COMFIRM';
      }
      return confirm;
    }
  },
  mounted() {
    this.showContent = true;
  },
  methods: {
    closeDialog() {
      if (this.type === 'newPopupWindow' && this.operateType === 'confirm') {
        this.$emit(CONFIRM_EVENT);
        return;
      }
      this.$emit(CANCEL_EVENT);
      if (this.operateType === 'confirm') {
        this.$emit(CONFIRM_EVENT);
      }
    },
    hideContent() {
      if (this.disableClose) return;
      this.showContent = false;
    },
    sendCancelEvt() {
      this.hideContent();
      this.operateType = 'cancel';
    },
    sendConfirmEvt() {
      this.hideContent();
      this.operateType = 'confirm';
    }
  },
  beforeDestroy() {
    this.showContent = false;
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialWebStore/_dimen.scss';

.dialog-wrap {
  display: flex;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 30;
  justify-content: center;
  align-items: center;
}

.dialog-container {
  position: relative;
  z-index: 10;
  width: 708px;
  border-radius: 10px;
  background: #fff;
  box-sizing: border-box;
  padding: 0;
}
.dialog-title {
  font-size: 26px;
  text-align: center;
  line-height: 86px;
  height: 86px;
  border-radius: 10px 10px 0 0;
  margin: 0;
  @include g-popup-title();
  margin-top: 0;
}

.dialog-tips-content {
  overflow-y: auto;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 12px;
  width: 100%;
  min-height: 80px;
  max-height: 400px;
  line-height: 40px;
  vertical-align: middle;
  text-align: center;
  font-size: 22px;
  color: #333;
  word-break: break-word;
  white-space: pre-wrap;
  &.notice {
    padding: 0 45px;
  }
  &.mb-30 {
    margin-bottom: 30px;
  }
}

.dialog-shade {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}
.left {
  text-align: left;
}
.center {
  display: block;
  box-sizing: border-box;
}
.close-btn {
  position: absolute;
  right: 32px;
  top: 27px;
  background: url($tmslgImg + 'close.png') no-repeat;
  width: 28px;
  height: 28px;
  cursor: pointer;
}
.account-ops {
  .cancel-btn {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    font-size: 24px;
    height: 80px;
    border-radius: 10px;
    padding: 0 74px;
    color: $btnBg;
    border: 1px solid $btnBg;
    margin-right: 26px;
    cursor: pointer;
  }
  .confirm-btn {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    font-size: 24px;
    height: 80px;
    border-radius: 10px;
    padding: 0 74px;
    color: #fff;
    background: $btnBg;
    cursor: pointer;
  }
  .long-btn {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    font-size: 24px;
    height: 80px;
    border-radius: 10px;
    padding: 0 74px;
    color: #fff;
    background: $btnBg;
  }
}

@media screen and (orientation: landscape) {
  .dialog-title {
    height: 61px;
    line-height: 61px;
    font-size: 22px;
  }
  .close-btn {
    position: absolute;
    right: 15px;
    top: 19px;
    background: url($tmslgImg + 'close.png') no-repeat;
    width: 23px;
    height: 23px;
    cursor: pointer;
    background-size: cover;
  }
}
</style>
